export const STATUS_TRANSLATIONS: Record<string, string> = {
  deployed: "Herausgegeben",
  deployable: "Verfügbar",
  undeployable: "Nicht verfügbar",
  archived: "Archiviert",
  pending: "Ausstehend",
};

export function translateStatus(name: string, meta: string): string {
  return STATUS_TRANSLATIONS[meta.toLowerCase()] ?? name;
}
